import { Component } from 'react';
import LazyLoad, { forceCheck } from 'react-lazyload';
import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { SingleItem } from '../SingleItem/SingleItem';
import { SingleItemMobile } from '../SingleItem/SingleItemMobile';
import { ConfigurationGroup } from '../ConfigurationGroup/ConfigurationGroup';
import { ConfigurationGroupMobile } from '../ConfigurationGroup/ConfigurationGroupMobile';
import { lazyRenderOffset, lazyPlaceholderHeight, lazyPlaceholderHeightMobile } from '../../../constants/constants';

class _SwitchGroups extends Component {
  renderConf(item, isMobile) {
    return isMobile
      ? (
        <LazyLoad key={item.ID} height={lazyPlaceholderHeightMobile} offset={lazyRenderOffset}>
          <ConfigurationGroupMobile group={item} />
        </LazyLoad>
      )
      : (
        <LazyLoad key={item.ID} height={lazyPlaceholderHeight} offset={lazyRenderOffset}>
          <ConfigurationGroup group={item} />
        </LazyLoad>
      );
  }

  renderSingleItem(card, isMobile) {
    return isMobile
      ? (
        <LazyLoad key={card.ID} height={lazyPlaceholderHeightMobile} offset={lazyRenderOffset}>
          <SingleItemMobile card={card} />
        </LazyLoad>
      )
      : (
        <LazyLoad key={card.ID} height={lazyPlaceholderHeight} offset={lazyRenderOffset}>
          <SingleItem card={card} />
        </LazyLoad>
      );
  }

  componentDidUpdate() {
    forceCheck();
  }

  render() {
    const { selectByGroupType, cardsType, uiStore } = this.props;

    return selectByGroupType.map((item) => {
      switch (item.type) {
        case cardsType.SINGLE:
          return item.selectCards.map((card) => this.renderSingleItem(card, uiStore.isMobile));

        case cardsType.GROUP:
          return this.renderConf(item, uiStore.isMobile);

        default:
          return this.renderSingleItem(item, uiStore.isMobile);
      }
    });
  }
}

_SwitchGroups.propTypes = {
  cardsType: propTypes.object,

  uiStore: propTypes.shape({
    isMobile: propTypes.bool
  }),

  selectByGroupType: propTypes.array
};

export const SwitchGroups = inject((allStores) => ({
  selectByGroupType: allStores.cartStore.selectByGroupType,
  cardsType: allStores.uiStore.cardsType,
  uiStore: allStores.uiStore
}))(observer(_SwitchGroups));
